exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#myInput {\n  border-radius: 15px;\n  /* border: 2px solid #18262F; */\n  padding: 7px;\n  width: 116px;\n  height: 17px;\n  font-size: 9px;\n  outline: none;\n  float: right;\n  margin-top: 2%; }\n\n.headStyle {\n  text-align: center;\n  font-size: 22px;\n  font-weight: 500;\n  color: #6b6a6a;\n  padding-top: 7px;\n  margin: 0px; }\n\n.sidebar {\n  height: 84vh;\n  width: 24%;\n  text-align: left;\n  background: white;\n  box-shadow: 3px 1px 5px 0px #b2b0ae;\n  position: fixed;\n  padding: 10px; }\n\n.main {\n  box-shadow: 3px 1px 5px 0px #b2b0ae;\n  padding: 10px;\n  background: white; }\n\n.topDiv {\n  padding-top: 59px;\n  background: whitesmoke;\n  height: 100vh; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/vtrackOneqlik/oneqlik_wetrack/src/app/fuel-price/fuel-price.component.scss
// module id = ../../../../../src/app/fuel-price/fuel-price.component.scss
// module chunks = main